import { ReactNode, useMemo } from 'react';
import { GrfqQuote } from '#/unified-rfqs/entities/grfq/domain';
import createSafeContext from '@paradigm/utils/createSafeContext';
import { TradeMatchData } from './types';
import useOnQuoteMatchedTrade from './useOnQuoteMatchedTrade';

interface OBQuoteMatching {
  isMatchingQuote: (quote: GrfqQuote) => boolean;
}
export type OnQuoteMatchFound = (
  tradeData: TradeMatchData,
  quote: GrfqQuote,
) => void;

export const [useObQuoteMatching, ObQuoteMatchingProviderCtx] =
  createSafeContext<OBQuoteMatching>('OBQuoteMatching');

interface Props {
  children: ReactNode;
  onMatchFound: OnQuoteMatchFound;
}
export default function ObQuoteMatchingProvider({
  children,
  onMatchFound,
}: Props) {
  const { matchedQuotes, onMarkQuoteNotified } =
    useOnQuoteMatchedTrade(onMatchFound);

  const actions: OBQuoteMatching = useMemo(
    () => ({
      isMatchingQuote: (quote) => {
        const matchedQuotesEntries = [...matchedQuotes.entries()];
        const [tradeId, matchedQuote] =
          matchedQuotesEntries.find(
            ([_, storedQuote]) => storedQuote.id === quote.id,
          ) ?? [];
        // Guarantee we only flash prices once
        if (tradeId == null || matchedQuote?.notified === true) return false;
        onMarkQuoteNotified(tradeId);
        return true;
      },
    }),
    [matchedQuotes, onMarkQuoteNotified],
  );

  return (
    <ObQuoteMatchingProviderCtx value={actions}>
      {children}
    </ObQuoteMatchingProviderCtx>
  );
}
